const CONSTANTS = {
  TOOLS: {
    ENABLE_JIRAPLANNERBOT: 'enable-jiraPlannerBot',
    ENABLE_ADOPLANNERBOT: 'enable-ADOPlannerBot',
    ENABLE_SONARQUBEAGENT: 'enable-sonarqube-agents',
    ENABLE_DEVOPSAGENT: 'enable-devops-agents',
    ENABLE_IQEAGENT: 'enable-iqe-agent',
  },
  QESCORE: {
    QESCORE_HELP_URL: 'https://devx.cbre.com/toolbox/1093',
    QESCORE_CONTACT_EMAIL: '!DT-GLOBAL-QEScore@cbre.com',
    QESCORE_TEAMS_CHANNEL:
      'https://teams.microsoft.com/l/channel/19%3A5862677abaa5413e95bd25d63433f298%40thread.tacv2/Quality%20Engineering?groupId=73ffb8ed-f68d-4c4e-8f2e-cbdc5b36c59c&tenantId=0159e9d0-09a0-4edf-96ba-a3deea363c28',
  },
};
export default CONSTANTS;
